import { CheckIcon } from '@radix-ui/react-icons';

import { useThemeContext } from '../../contexts/ThemeContext';
import { resolveColor } from '../customTheme/theme/utils/resolveColor';
import { PoweredByQITech } from '../customTheme/PrivatePayrollAuction/components/PoweredByQITech';
import QISignTheme from '../../interfaces/Theme';
import * as S from './styles';

interface EnvelopeFolderSignedProps {
    resolvedTheme: QISignTheme;
    keptCount?: number;
    canceledCount?: number;
}

export const EnvelopeFolderSigned = (props: EnvelopeFolderSignedProps) => {
    const { resolvedTheme, keptCount, canceledCount } = props;

    const { clientThemeSettings } = useThemeContext();
    const theme: QISignTheme = clientThemeSettings ?? resolvedTheme;
    const primary = resolveColor('primary', theme);
    const text = resolveColor('text', theme);

    const showCounts = keptCount != null || canceledCount != null;

    return (
        <S.PageWrapper>
            <S.LogoSection>
                {theme.logo_url && <S.LogoImage src={theme.logo_url} alt="logo" />}
            </S.LogoSection>

            <S.Content>
                <S.CheckCircle $color={primary}>
                    <CheckIcon width={48} height={48} color={primary} />
                </S.CheckCircle>

                <S.Title $color={text}>Recebemos suas propostas e já estamos analisando</S.Title>

                <S.Subtitle>
                    Se aprovadas, os valores serão depositados direto na sua conta e as parcelas
                    serão descontadas do seu benefício INSS.
                </S.Subtitle>

                {showCounts && (
                    <S.CountsCard $color={primary}>
                        <S.CountCell>
                            <S.CountValue $color={primary}>{keptCount ?? 0}</S.CountValue>
                            <S.CountLabel>aceitas</S.CountLabel>
                        </S.CountCell>
                        {canceledCount != null && (
                            <>
                                <S.CountDivider />
                                <S.CountCell>
                                    <S.CountValue $color="#718096">{canceledCount}</S.CountValue>
                                    <S.CountLabel>canceladas</S.CountLabel>
                                </S.CountCell>
                            </>
                        )}
                    </S.CountsCard>
                )}
            </S.Content>

            <S.Separator />

            <S.Footer>
                <PoweredByQITech />
            </S.Footer>
        </S.PageWrapper>
    );
};
